export { IBaseModel } from './ibase.model';
export { IGenericRepositoryService } from './igeneric-repository.service';
